import styled from 'vue-styled-components'

const GroupTitle = styled.p`
color: #8e969e;
background: #F8F9FA;
margin-left: -20px;
margin-right: -20px;
margin-bottom:0px;
padding: 2px 20px;
text-transform: capitalize;
`
const PageItem = styled.div`
text-align: center ;
max-height:500px ;
padding: 5px 20px 5px 20px;
margin-left: -20px;
margin-right: -20px;
.icon-style {
    font-size: 14px;
    color: #84929F;
}
.tool {
    display: none;
}
&.pl-35 {
    padding-left : 35px;
}

&:hover {
    background-color: #f4fcff;
    .tool {
        display: inline-block;
        .btn {
            padding: 0px;
            border: 0px;
        }
        .option {
            &:hover {
                background-color: #f4fcff;
            }
        }
    }    
    /* .disabled.text-muted {
        display: none;
    } */
}
.popover-body {
        padding: 10px 0;
        .option {
          color: #373E44;
          padding: 5px 20px;
        }
    }
&.bactive.active , .bactive:active{
    .tool {
        display: block;
    }
}

.tools-more-menu {
    width: 20px;
    height: 20px;
    padding: 0;
    border-radius: 50%;
    background: transparent;
    border: none;

    text-align: center;
    outline: 1px solid #BDEBF6;
        &:hover {
            outline: 2px solid #BDEBF6;
        }
        &.active{
            outline: 2px solid #24BEE2;
        }
    
}
.popover {
    border: 0px;
    box-shadow: 0px 16px 48px 0px rgb(0 0 0 / 18%);
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
    border-width: 0px;
    box-shadow: 0px 16px 48px 0px rgb(0 0 0 / 18%);

}
.homeactive{
    color: #24BEE2
}
`
const Wrapper = styled.div`
padding: 5px;
    .nav.nav-tabs{
        display: none;
    }
`

const CheckIcon = styled.span`
    svg {
        font-size: 10px !important;
    }
    bottom: -2px;
    left: 7px;
`;
export {
    GroupTitle,
    PageItem,
    Wrapper,
    CheckIcon,
}